/// <amd-module name="Wit/Search/InstantSearchBanner/InstantSearchBanner" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { Button } from "VSSUI/Button";
import { IGlobalMessagesService } from "TFS/GlobalBanner/GlobalMessagesService.Types";
import * as Resources from "Wit/Search/InstantSearchBanner/Resources";

class InstantSearchBannerComponent extends VssComponent<{}, {}> {
    public static componentType = "instantSearchBanner";

    public render(): JSX.Element {
        return (
            <>
                <div className="instant-search-banner-message flex-row flex-grow fontSizeM">
                    <b className="instant-search-feature-name">{format("{0}:", Resources.InstantSearchFeatureLabel)}</b>
                    <span>{Resources.InstantSearchBannerMessage}</span>
                </div>
                <Button primary={true} text={Resources.TryItButtonLabel} onClick={this._onTryItClick}></Button>
            </>
        );
    }

    private _onTryItClick = (): void => {
        // Dismiss banner
        const globalMessagesService = this.context.pageContext.getService<IGlobalMessagesService>("IGlobalMessagesService");
        globalMessagesService.closeBanner();

        // Focus on L1 search box
        const searchInput = document.getElementById("l1-search-input");
        if (searchInput) {
            searchInput.focus();
        }

        // Record telemetry
        const telemetryService: IVssTelemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("Web", "WikiSearchSuggestions", { event: "TryItButtonClicked" });
    }
}

VssComponent.register(InstantSearchBannerComponent.componentType, InstantSearchBannerComponent);
